<div class="modal-header" *ngIf="view !== ViewEnum.close">
    <h5 class="modal-title">Sign up as a student</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body" *ngIf="view === ViewEnum.chose">
    <div class="row">
        <div class="col-12 mb-6">
            <div>
                Would you like to create a new PBS LearningMedia account, or use your Google account
                to sign up?
            </div>
            <div class="note">(Note: You will not be able to change this in the future.)</div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-6 mb-6">
            <app-button (click)="view = ViewEnum.create" class="pbs-create-btn"
                >Create PBS LearningMedia Account</app-button
            >
        </div>

        <div class="col-lg-6">
            <div class="google-auth-wrapper">
                <a
                    [href]="
                        userService.getGoogleAuthUrl(studentLogin.getCurrentStudentPath(), true)
                    "
                    class="selenium-continue-google"
                >
                    <img class="auth-icon" [src]="googleImage" alt="Google Auth" />
                    Continue with Google
                </a>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 mb-6">
            <p>
                Are you a teacher?
                <a [routerLink]="['/signup']" (click)="activeModal.close()">Sign up here ></a>
            </p>
        </div>
    </div>
</div>

<div class="modal-body" *ngIf="view === ViewEnum.create">
    <div class="row">
        <div class="col-12">
            <p>
                Are you a teacher?
                <a [routerLink]="['/signup']" (click)="activeModal.close()">Sign up here ></a>
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h4>Create Your Username!</h4>
        </div>
    </div>

    <div class="row" *ngIf="error">
        <div class="col-12">
            <div class="alert alert-danger" role="alert">
                {{ error }}
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <p>
                Choose carefully! Your username will follow you around the site, and your teacher
                will see it on your assignments.
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-4 mb-6">
            <div class="label mb-2"><span class="mr-2">1</span>What is your first name?</div>
            <input
                type="text"
                class="w-100 p-2"
                placeholder="Enter first name"
                (keydown.space)="$event.preventDefault()"
                [(ngModel)]="customWord"
                (ngModelChange)="updateUserName()"
            />
        </div>
        <div class="col-lg-4 mb-6">
            <div class="label mb-2"><span class="mr-2">2</span>Choose a description!</div>
            <app-input-carousel
                [items]="wordList1"
                (itemChanged)="setWord1($event)"
            ></app-input-carousel>
        </div>
        <div class="col-lg-4 mb-6">
            <div class="label mb-2"><span class="mr-2">3</span>Choose a thing!</div>
            <app-input-carousel
                [items]="wordList2"
                (itemChanged)="setWord2($event)"
            ></app-input-carousel>
        </div>
    </div>

    <div class="row mb-6" *ngIf="customWord">
        <div class="col-12">
            <span>Your username is:</span> <span class="font-weight-bold"> {{ tmpUsername }}</span>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h4>Pick a Question and Set Your Answer</h4>
        </div>
        <div class="col-12">
            <p>Your secret question and username are for logging into your account.</p>
        </div>
    </div>

    <div class="row mb-6">
        <div class="col-12">
            <ng-select
                [items]="secretQuestions"
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="selectedQuestion"
            >
            </ng-select>
        </div>
    </div>

    <div class="row mb-6" *ngIf="selectedQuestion">
        <div class="col-12">
            <input
                type="text"
                class="w-100 p-2"
                [(ngModel)]="questionAnswer"
                placeholder="Enter answer here"
            />
        </div>
    </div>

    <div class="row recaptcha-text">
        <div class="col-12">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
        </div>
    </div>
</div>

<div class="modal-body" *ngIf="view === ViewEnum.review">
    <div class="row mb-6">
        <div class="col-12">Write this down or print it out. Keep it somewhere safe.</div>
    </div>

    <div class="row mb-6">
        <div class="col-12">
            <div class="info-review">
                Username: <span class="font-weight-bold">{{ tmpUsername }}</span>
            </div>
            <div class="info-review">
                <div>Secret Question: {{ getQuestionText(selectedQuestion) }}</div>
                <div>Answer: {{ questionAnswer.toLowerCase() }}</div>
            </div>
        </div>
    </div>
</div>

<div class="modal-body cancel-view" *ngIf="view === ViewEnum.close">
    <div class="row mb-2">
        <div class="col-12">
            <h3 class="modal-title">Cancel sign up?</h3>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-12">
            <p>Closing this window will discard your changes. Are you sure?</p>
        </div>
    </div>

    <div class="row">
        <div class="col-12 float-right exit-btns">
            <app-button class="no-btn" (click)="view = prevView"> No, Continue sign up </app-button>

            <app-button (click)="activeModal.dismiss('Cross click')">
                Yes, discard changes
            </app-button>
        </div>
    </div>
</div>

<div class="modal-footer p-0 pt-6" *ngIf="view !== ViewEnum.close && view !== ViewEnum.chose">
    <app-button
        class="mr-auto back-btn"
        *ngIf="view === ViewEnum.review"
        (click)="prevPage()"
        [btnHoverColor]="'#fff'"
    >
        Back
    </app-button>

    <app-button *ngIf="view === ViewEnum.create" [disable]="!isFormValid()" (click)="nextPage()">
        Next
    </app-button>

    <app-button
        *ngIf="view === ViewEnum.review"
        [disable]="!isFormValid()"
        (click)="createStudent()"
    >
        Create my account
    </app-button>
</div>
